import React from "react"
import PropTypes from "prop-types"
import UtilizationRangeFilter from "../UtilizationRangeFilter"
import UtilizationSummaryTableWithData from "./UtilizationSummaryTableWithData"
import { SortDirection } from "react-virtualized"
import DepartmentDropdown from "../DepartmentDropdown"
import SearchBox from "../SearchBox"
import "./UtilizationSummaryTableControlled.scss"

class UtilizationSummaryTableControlled extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filters: ["all"],
      searchValue: "",
      sortBy: "asset",
      sortDirection: SortDirection.ASC,
      selectedDepartment: undefined,
    }
  }

  handleDepartmentChange = selectedDepartment => {
    if (selectedDepartment.value === null) selectedDepartment = undefined
    this.setState({ selectedDepartment })
  }

  handleSearchChange = query => {
    this.setState({ searchValue: query })
  }

  handleSortChange = column => {
    this.setState(prevState => ({
      sortBy: column,
      sortDirection:
        prevState.sortBy === column &&
        prevState.sortDirection === SortDirection.ASC
          ? SortDirection.DESC
          : SortDirection.ASC,
    }))
  }

  handleFilterChange = clickedKey => {
    this.setState(prevState => {
      let selected
      if (clickedKey === "all") {
        selected = ["all"]
      } else if (prevState.filters.includes(clickedKey)) {
        selected = prevState.filters.filter(item => item !== clickedKey)
      } else {
        selected = [clickedKey, ...prevState.filters].filter(
          item => item !== "all"
        )
      }

      if (selected.length === 0 || selected.length >= 4) selected = ["all"]

      return { filters: selected }
    })
  }

  onRowClick = ({ entityId, deviceTypeId }) => {
    this.props.pushPath(`/facility/${entityId}/utilization/${deviceTypeId}`)
  }

  render() {
    return (
      <div className="UtilizationSummaryTableControlled">
        <div className="controls">
          <h2>All Assets</h2>
          <div className="owned-by">
            <span>Show Assets owned by</span>
            <DepartmentDropdown
              loading={this.props.loading}
              departments={this.props.departments}
              departmentUpdated={this.handleDepartmentChange}
            />
          </div>
        </div>
        <div className="controls">
          <UtilizationRangeFilter
            selected={this.state.filters}
            handleChange={this.handleFilterChange}
          />
          <SearchBox
            onChange={this.handleSearchChange}
            query={this.state.searchValue}
          />
        </div>
        <UtilizationSummaryTableWithData
          loading={this.props.loading}
          entityId={
            this.state.selectedDepartment
              ? this.state.selectedDepartment.value
              : this.props.defaultEntityId
          }
          entityType={
            this.state.selectedDepartment
              ? "department"
              : this.props.defaultEntityType
          }
          owningDeptId={
            this.state.selectedDepartment
              ? this.state.selectedDepartment.value
              : undefined
          }
          onSortChange={this.handleSortChange}
          onRowClick={this.props.pushPath ? this.onRowClick : undefined}
          sortBy={this.state.sortBy}
          sortDirection={this.state.sortDirection}
          filters={this.state.filters}
          searchValue={this.state.searchValue}
        />
      </div>
    )
  }
}

UtilizationSummaryTableControlled.propTypes = {
  defaultEntityId: PropTypes.string,
  defaultEntityType: PropTypes.oneOf(["facility", "department"]),
  departments: DepartmentDropdown.propTypes.departments,
  loading: PropTypes.bool,
  pushPath: PropTypes.func,
}

export default UtilizationSummaryTableControlled
